/**
 * Store 绑定 key 工具：统一使用 sessionId 前缀，避免全局命名冲突
 */

/**
 * 获取 dataSet 的 store key。
 * 有 sessionId 时用 sessionId_dataSet；否则退回 dataSet（兼容无 sessionId 场景）。
 */
export function getDataSetStoreKey(
  sessionId: string | undefined,
  dataSet: string | undefined
): string | undefined {
  if (!dataSet) return undefined;
  return sessionId ? `${sessionId}_${dataSet}` : dataSet;
}

/**
 * 获取校验结果 store 的 key（validateStore）。
 * 有 sessionId 时用 sessionId_dataSet_validate；否则用 dataSet_validate。
 */
export function getValidateStoreKey(
  sessionId: string | undefined,
  dataSet: string | undefined
): string | undefined {
  if (!dataSet) return undefined;
  return sessionId ? `${sessionId}_${dataSet}_validate` : `${dataSet}_validate`;
}
